<template>
  <svg
    class="replay-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="35"
    viewBox="0 0 31 35"
    fill="none"
  >
    <path
      d="M15.0425 35C12.9541 35 10.9973 34.604 9.17209 33.812C7.34686 33.0199 5.7579 31.9476 4.40521 30.5948C3.05249 29.2421 1.98011 27.6532 1.18807 25.828C0.396022 24.0028 0 22.0499 0 19.9693H3.71551C3.71551 23.1214 4.81431 25.7953 7.01191 27.991C9.20947 30.1866 11.8857 31.2845 15.0405 31.2845C18.1926 31.2845 20.8665 30.1857 23.0621 27.9881C25.2578 25.7905 26.3556 23.1143 26.3556 19.9596C26.3556 16.8075 25.2569 14.1336 23.0593 11.9379C20.8617 9.74221 18.1855 8.64436 15.0307 8.64436H14.776L17.2293 11.0977L14.8354 13.5733L8.04882 6.78661L14.8354 0L17.2293 2.48527L14.7857 4.92885H15.0307C17.1196 4.92885 19.0762 5.32487 20.9005 6.11692C22.7248 6.90896 24.3149 7.98133 25.6709 9.33402C27.0268 10.6867 28.1008 12.2743 28.8929 14.0966C29.6849 15.919 30.0809 17.8735 30.0809 19.9601C30.0809 22.0468 29.6849 24.0028 28.8929 25.828C28.1008 27.6532 27.0285 29.2421 25.6757 30.5948C24.323 31.9476 22.7348 33.0199 20.9109 33.812C19.087 34.604 17.1309 35 15.0425 35Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ReplayIcon",
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.replay-icon {
  path {
    fill: $aisea-blue;
  }
}
</style>
